import React from 'react';
import { MobileBottomDrawer } from 'ui/MobileBottomDrawer/MobileBottomDrawer';

export enum EVideoPlatform {
  VIMEO = 'VIMEO',
}

interface IVideoDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  type: EVideoPlatform;
  videoId: string;
  title: string;
}

const videoPlatformMapping = {
  [EVideoPlatform.VIMEO]: 'https://player.vimeo.com/video/',
};

export const VideoDrawer = (props: IVideoDrawerProps) => {
  const videoUrl = videoPlatformMapping[props.type];

  return (
    <MobileBottomDrawer isOpen={props.isOpen} onClose={props.onClose} title={props.title}>
      {videoUrl ? (
        <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`${videoUrl}${props.videoId}`}
            allow="autoplay; fullscreen;"
          />
        </div>
      ) : (
        <div className="flex items-center justify-center h-[200px] bg-dark-black">
          <div className="flex flex-col">
            <span className="font-hurmegeometric-sans text-[24px] leading-[27px] text-white-true font-bold text-center">
              Sorry
            </span>
            <span className="font-hurmegeometric-sans text-[16px] leading-[20px] text-white-true mt-[10px] text-center">
              There was a problem loading this video
            </span>
          </div>
        </div>
      )}
    </MobileBottomDrawer>
  );
};
